/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from "react";
import { useFormik } from "formik";
import { Button, Col, Form, FormGroup, Label, Row } from "reactstrap";
import * as Yup from "yup";
import { toast } from "react-toastify";
import moment from "moment";

import { StyledSelect } from "../StyledSelect";
import useFetcher from "../../hooks/useFetcher";
import { handleErrors } from "../../services/handleErrors";
import { useAuth } from "../../context/AuthContext";
import { queryDateFormat } from "../../../config/constants";
import { fetchNovedadPiAsignable } from "../../services/novedadesServices";
import { fetchAlertaCategories, createAlerta, editarAlerta } from "../../services/alertasServices";
import { fetchTaskCategories } from "../../services/taskServices";

import modulos from "../../mocks/modulos";

const AlertEdit = ({ alertSelected, isAdmin = false, noEdit = false, isAudit }) => {
  const alertaInfo = alertSelected;
  // const { novedadId } = taskEdit;
  const { refreshToken, currentUser } = useAuth();
  // const [categories, isLoadingCategories] = useFetcher(fetchTaskCategories);
  const [pisAsignable, isLoadingAsignable] = useFetcher(fetchNovedadPiAsignable);
  const today = moment().format(queryDateFormat);
  const [opcionAsignable, setAsignable] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [changes, setChanges] = useState({
    tipo: false,
    concepto: false,
    dueDate: false,
    responsableId: false,
    observadorId: false,
    liderId: false,
  });

  const formik = useFormik({
    initialValues: {
      type: alertaInfo.type || "",
      concepto: alertaInfo.concepto || "",
      dueDate: moment(alertaInfo.dueDate).format(queryDateFormat),
      completeDate: alertaInfo.completeDate ? moment(alertaInfo.completeDate).format(queryDateFormat) : null,
      observations: alertaInfo.observations || "",
      responsableId: alertaInfo.responsableId || "",
      liderId: alertaInfo.liderId || "",
    },
    onSubmit: async () => {
      // try {
      //   const taskToUpdate = { ...task, id: taskEdit.id };
      //   const { message, result } = await patchTask(novedadId, taskToUpdate);
      //   newTaskUpdated(result);
      //   toast.success(message);
      // } catch (error) {
      //   handleErrors(error, toast.error, refreshToken, formik);
      // }
    },
    validationSchema: Yup.object().shape({
      type: Yup.number().typeError("Debe seleccionar un tipo de la lista").required("Este campo es requerido."),
      responsableId: Yup.number().typeError("Debe seleccionar un responsable").required("Este campo es requerido."),
      concepto: Yup.number().typeError("Debe seleccionar un concepto").required("Este campo es requerido."),
      dueDate: Yup.date().typeError("Debe elegir una fecha de vencimiento").required("Este campo es requerio."),
      observations: Yup.string().nullable().notRequired(),
    }),
  });

  const tipoOptions = opcionAsignable
    ? opcionAsignable.tarea.type.map((assigned) => {
        return { label: assigned.text, value: assigned.id };
      })
    : [];

  const piOptions = pisAsignable
    ? pisAsignable.map((assigned) => {
        return { label: assigned.nombreApellido, value: assigned.itemId };
      })
    : [];

  let responsableValue = piOptions.find((option) => {
    return option.value === formik.values.responsableId;
  });

  responsableValue = responsableValue || null;

  const conceptoOptions = opcionAsignable
    ? opcionAsignable.concepto.type.map((assigned) => {
        return { label: assigned.text, value: assigned.id };
      })
    : [];

  const conceptoOptionsFiltered = conceptoOptions && formik.values.type !== 1 ? conceptoOptions.filter((item) => item.value === 5) : conceptoOptions;

  let conceptoValue = conceptoOptionsFiltered.find((option) => {
    return option.value === formik.values.concepto.id;
  });

  conceptoValue = conceptoValue || null;

  let liderValue = piOptions.find((option) => {
    return option.value === formik.values.liderId;
  });

  liderValue = liderValue || null;

  const handleBlur = (value) => {
    if (alertaInfo) {
      if (formik.values[value] !== alertaInfo[value]) {
        setChanges((prevState) => ({ ...prevState, [value]: true }));
      } else {
        setChanges((prevState) => ({ ...prevState, [value]: false }));
        return;
      }
    }
    if (formik.values[value] != null) {
      setChanges((prevState) => ({ ...prevState, [value]: true }));
    } else {
      setChanges((prevState) => ({ ...prevState, [value]: false }));
    }
  };

  useEffect(async () => {
    try {
      setIsLoading(true);
      const categories = await fetchAlertaCategories();
      setAsignable(categories);
    } catch (error) {
      handleErrors(error);
    }
    setIsLoading(false);
  }, []);

  return (
    <div className="container-fluid">
      <Form onSubmit={formik.handleSubmit}>
        <Row>
          <Col>
            <FormGroup>
              <Label htmlFor="type" className="col-form-label pt-0 w-100">
                Tipo de tarea
              </Label>
              <StyledSelect
                className={`w-100 ${formik.errors.type && formik.touched.type ? "error-field" : ""}`}
                id="type"
                name="type"
                formik={formik}
                value={
                  tipoOptions.find((option) => {
                    return option.value === formik.values.type;
                  }) || ""
                }
                isLoading={isLoading}
                options={tipoOptions}
                placeholder="Seleccione tipo de tarea"
                isClearable
                isDisabled={formik.isSubmitting || isLoading || !isAdmin || noEdit || isAudit}
                onChange={(v) => {
                  if (v.value === 2 || v.value === 3 || v.value === 4) {
                    formik.setFieldValue("concepto", null);
                  }
                }}
              />

              {formik.errors.type && formik.touched.type && <div className="input-feedback">{formik.errors.type}</div>}
              {changes.tipo ? (
                <div style={{ height: "10px", padding: "0px" }} className="input-feedback m-1 d-flex flex-column align-items-end">
                  Cambios por guardar
                </div>
              ) : (
                <div style={{ height: "10px", padding: "0px" }} />
              )}
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col>
            <FormGroup>
              <Label className="col-form-label pt-0"> Concepto </Label>
              <StyledSelect
                id="concepto"
                name="concepto"
                className="w-100"
                formik={formik}
                required
                value={conceptoValue}
                placeholder="Seleccione concepto"
                isClearable
                isDisabled={noEdit || isLoading || isAudit}
                isLoading={isLoading}
                options={conceptoOptionsFiltered}
                onBlur={() => handleBlur("concepto")}
              />
              {formik.errors.concepto && formik.touched.concepto && <div className="input-feedback">{formik.errors.concepto}</div>}
              {changes.concepto ? (
                <div style={{ height: "10px", padding: "0px" }} className="input-feedback m-1 d-flex flex-column align-items-end">
                  Cambios por guardar
                </div>
              ) : (
                <div style={{ height: "10px", padding: "0px" }} />
              )}
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col>
            <FormGroup>
              <Label className="col-form-label pt-0"> Responsable </Label>
              <StyledSelect
                className={`w-100 ${formik.errors.responsableId && formik.touched.responsableId ? "error-field" : ""}`}
                id="responsableId"
                name="responsableId"
                formik={formik}
                value={responsableValue}
                placeholder="Seleccione asignado"
                isClearable
                isLoading={isLoadingAsignable}
                options={piOptions}
                isDisabled={formik.isSubmitting || isLoadingAsignable || !isAdmin || noEdit || isAudit}
              />
              {formik.errors.responsableId && formik.touched.responsableId && <div className="input-feedback">{formik.errors.responsableId}</div>}
              {changes.responsableId ? (
                <div style={{ height: "10px", padding: "0px" }} className="input-feedback m-1 d-flex flex-column align-items-end">
                  Cambios por guardar
                </div>
              ) : (
                <div style={{ height: "10px", padding: "0px" }} />
              )}
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col>
            <FormGroup>
              <Label className="col-form-label pt-0"> Lider </Label>
              <StyledSelect
                className={`w-100 ${formik.errors.liderId && formik.touched.liderId ? "error-field" : ""}`}
                id="liderId"
                name="liderId"
                formik={formik}
                value={liderValue}
                placeholder="Seleccione asignado"
                isClearable
                isLoading={isLoadingAsignable}
                options={piOptions}
                isDisabled={noEdit || formik.isSubmitting || isLoadingAsignable || !isAdmin || isAudit}
              />
              {formik.errors.liderId && formik.touched.liderId && <div className="input-feedback">{formik.errors.liderId}</div>}
            </FormGroup>
          </Col>
        </Row>
        <Row>
          <Col>
            <FormGroup>
              <Label htmlFor="dueDate" className="col-form-label pt-0 w-100">
                Fecha vencimiento
              </Label>

              <input
                className={formik.errors.dueDate && formik.touched.dueDate ? "form-control error-field" : "form-control"}
                type="date"
                name="dueDate"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.dueDate}
                min={today}
                disabled={formik.isSubmitting || !currentUser.getMetadata(modulos.CALENDAR, "canEditDueDate") || noEdit || isAudit}
              />

              {formik.errors.dueDate && formik.touched.dueDate && <div className="input-feedback">{formik.errors.dueDate}</div>}
            </FormGroup>
          </Col>
        </Row>
        {alertaInfo.completeDate && (
          <Row>
            <Col>
              <FormGroup>
                <Label htmlFor="resolucion" className="col-form-label pt-0 w-100">
                  Resolución
                </Label>
                <input
                  className={formik.errors.completeDate && formik.touched.completeDate ? "form-control error-field" : "form-control"}
                  type="date"
                  name="resolucion"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.completeDate}
                  min={today}
                  disabled={!isAdmin || noEdit || isAudit}
                />
                {formik.errors.completeDate && formik.touched.completeDate && <div className="input-feedback">{formik.errors.completeDate}</div>}
              </FormGroup>
            </Col>
          </Row>
        )}

        <Row>
          <Col>
            <FormGroup>
              <Label htmlFor="observations" className="col-form-label pt-0 w-100">
                Observaciones
              </Label>
              <textarea
                className={formik.errors.observations && formik.touched.observations ? "form-control error-field" : "form-control"}
                name="observations"
                disabled={formik.isSubmitting || noEdit || isAudit}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.observations}
              />
              {formik.errors.observations && formik.touched.observations && <div className="input-feedback">{formik.errors.observations}</div>}
            </FormGroup>
          </Col>
        </Row>
        {/* <FormGroup>
          <Button disabled type="submit">
            Guardar Cambios
          </Button>
        </FormGroup> */}
      </Form>
    </div>
  );
};

export default AlertEdit;
